export default __webpack_public_path__ + "static/media/new-unpublish-icon.e1c225fb.svg";